module.exports = __webpack_public_path__ + "media/bg4.c0aba4df.mp4";